export enum Env {
    Dev = 'DEV',
    Staging = 'STAGING',
    Prod = 'PROD',
}